<template>
    <footer class="footer-section">
        <div class="footer-content">
            <div class="footer-brand">
                <h3 class="logo">curie</h3>
                <p class="tagline">Your HSC Chemistry Advantage</p>
            </div>

            <div class="footer-links">
                <div class="link-group">
                    <h4>Navigation</h4>
                    <router-link to="/">Home</router-link>
                    <router-link to="/about">About</router-link>
                    <router-link to="/login">Login</router-link>
                    <router-link to="/register">Register</router-link>
                </div>

                <div class="link-group">
                    <h4>Legal</h4>
                    <router-link to="/privacy">Privacy Policy</router-link>
                    <router-link to="/terms">Terms of Service</router-link>
                </div>

                <div class="link-group">
                    <h4>Contact</h4>
                    <a :href="'mailto:' + config.contact.email">{{ config.contact.email }}</a>
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <p>&copy; {{ currentYear }} Curie. All rights reserved.</p>
        </div>
    </footer>
</template>

<script>
import { SITE_CONFIG } from '@/config/site';

export default {
    name: 'FooterSection',
    data() {
        return {
            config: SITE_CONFIG
        };
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
};
</script>

<style scoped>
.footer-section {
    position: relative;
    z-index: 2;
    padding: 60px 20px 30px;
    max-width: 80vw;
    margin: 0 auto;
    border-top: 1px solid var(--accent);
}

.footer-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 40px;
    margin-bottom: 40px;
}

.footer-brand {
    max-width: 300px;
}

.logo {
    font-family: 'Crimson Pro', 'Times New Roman', serif;
    font-size: 32px;
    font-weight: 400;
    color: var(--accent);
    margin-bottom: 8px;
}

.tagline {
    color: var(--text-secondary);
    font-size: 14px;
}

.footer-links {
    display: flex;
    gap: 60px;
    flex-wrap: wrap;
}

.link-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.link-group h4 {
    color: var(--text-primary);
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    margin-bottom: 4px;
}

.link-group a {
    color: var(--text-secondary);
    text-decoration: none;
    font-size: 14px;
    transition: color 0.2s ease;
}

.link-group a:hover {
    color: var(--accent);
}

.footer-bottom {
    padding-top: 30px;
    border-top: 1px solid rgba(var(--accent-rgb), 0.2);
    text-align: center;
}

.footer-bottom p {
    color: var(--text-secondary);
    font-size: 13px;
}

@media (max-width: 768px) {
    .footer-section {
        max-width: 100%;
        padding: 40px 20px 20px;
    }

    .footer-content {
        flex-direction: column;
        gap: 30px;
    }

    .footer-links {
        gap: 30px;
    }

    .footer-brand {
        text-align: center;
        max-width: 100%;
    }

    .link-group {
        align-items: center;
        text-align: center;
    }
}
</style>
